/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdLimits } from "./constants";
import type { EngagementLandingPagesAppGroupIdLimitsResult } from "./types";

export const getEngagementLandingPagesAppGroupIdLimits = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdLimits,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementLandingPagesAppGroupIdLimitsResult> => {
    return fetch(`/engagement/landing_pages/${appGroupId}/limits`, "GET", {}, { signal });
  }
);
